import { render, staticRenderFns } from "./AspectDefault.vue?vue&type=template&id=9261f088&scoped=true&"
import script from "./AspectDefault.vue?vue&type=script&lang=js&"
export * from "./AspectDefault.vue?vue&type=script&lang=js&"
import style0 from "./AspectDefault.vue?vue&type=style&index=0&id=9261f088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9261f088",
  null
  
)

export default component.exports